import React from "react";
import { CalendarPlus, Download } from "lucide-react";

// Builds a downloadable .ics file and a Google Calendar link for an event.
const pad = (n) => String(n).padStart(2, "0");
const toICSDate = (d) => `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

export const AddToCalendar = ({ title, start, durationHours = 3, description = "", location = "" }) => {
  if (!start) return null;
  const startDate = new Date(start);
  if (isNaN(startDate.getTime())) return null;
  const endDate = new Date(startDate.getTime() + durationHours * 3600 * 1000);
  const clean = (s) => (s || "").replace(/[\n\r]+/g, " ").trim();

  const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE`
    + `&text=${encodeURIComponent(title || "Tournoi")}`
    + `&dates=${toICSDate(startDate)}/${toICSDate(endDate)}`
    + `&details=${encodeURIComponent(clean(description))}`
    + `&location=${encodeURIComponent(clean(location))}`;

  const downloadIcs = () => {
    const ics = [
      "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Arcanapp//FR", "CALSCALE:GREGORIAN",
      "BEGIN:VEVENT",
      `UID:${Date.now()}@arcanapp.com`,
      `DTSTAMP:${toICSDate(new Date())}`,
      `DTSTART:${toICSDate(startDate)}`,
      `DTEND:${toICSDate(endDate)}`,
      `SUMMARY:${clean(title)}`,
      `DESCRIPTION:${clean(description)}`,
      `LOCATION:${clean(location)}`,
      "END:VEVENT", "END:VCALENDAR",
    ].join("\r\n");
    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(title || "tournoi").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="add-to-calendar">
      <a href={googleUrl} target="_blank" rel="noreferrer"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-[#252525] hover:bg-[#333] text-white text-sm font-medium transition-colors" data-testid="add-cal-google">
        <CalendarPlus className="w-4 h-4 text-[#4ECDC4]" />Ajouter à Google Agenda
      </a>
      <button onClick={downloadIcs}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-[#252525] hover:bg-[#333] text-white text-sm font-medium transition-colors" data-testid="add-cal-ics">
        <Download className="w-4 h-4 text-[#FF6B35]" />Télécharger (.ics)
      </button>
    </div>
  );
};

export default AddToCalendar;
